import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { ServicePlanBillingPolicy } from 'src/features/servicePlanBillingPolicies/utils/types';
import DeleteServicePlanBillingPolicyFormModal from 'src/features/servicePlanBillingPolicies/components/forms/DeleteServicePlanBillingPolicyFormModal';
import UpdateServicePlanBillingPolicyFormModal from 'src/features/servicePlanBillingPolicies/components/forms/UpdateServicePlanBillingPolicyFormModal';
import { billingPoliciesMessages } from 'src/features/servicePlanBillingPolicies/utils/messages';

type CellServicePlanBillingPolicyActions = {
    row: Row<ServicePlanBillingPolicy>;
};

export default function CellServicePlanBillingPolicyActions({ row }: CellServicePlanBillingPolicyActions) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateServicePlanBillingPolicyFormModal
                        semantics={{ entryName: formatMessage(billingPoliciesMessages.policy).toLowerCase() }}
                        selectedServicePlanBillingPolicy={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateServicePlanBillingPolicyFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteServicePlanBillingPolicyFormModal selectedServicePlanBillingPolicy={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteServicePlanBillingPolicyFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
